export enum Page {
  Terms = 'terms',
  ForEntrepreneurs = 'companies',
  Contacts = 'contacts',
  AboutCard = 'about_card',
}
